export function CustomIcon({ icon = '', className = '' }: { icon: string; className?: string }) {
  return <img className={className} src={`/icons/${icon}.svg`} alt={icon} />;
}
